import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

import { Ripple } from 'vuetify/lib/directives'


Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#ba0a15',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c',
    // paco
    paco_rouge: '#ba0a15',
    paco_rouge_fonce: '#58302d',
    paco_rouge_pure: '#f00',
    paco_gris_fonce: '#4f565b',
    paco_rouge_moyen: '#75828f',
    paco_vert: '#cbff00',
    paco_vert_ecran: '#42c125',
    paco_orange: '#ff8400'
  },
  directives: {
    Ripple
  }
})
